<div class="card popover-card" :class="{ 'is-open': isOpen }">
	<button
		type="button"
		class="card-header"
		:ref="fl.setReference"
		:aria-controls="id"
		:aria-expanded="isOpen"
		@click="toggle"
	>
		<span class="card-header-title">
			<slot name="title"/>
		</span>
		<span class="card-header-icon" aria-hidden="true">
			<b-icon :icon="iconName"></b-icon>
		</span>
	</button>
	<div
		v-show="isOpen"
		:ref="fl.setFloating"
		:id="id"
		class="card popover-card-floating"
		:style="floatingStyle"
		role="dialog"
	>
		<div class="card-content">
			<div class="content">
				<slot/>
			</div>
		</div>
	</div>
</div>
